import {
  Textfield as CXTextfield,
  TextfieldMaskType as CXTextfieldMaskType,
  ITextfield as CXITextfield,
  MASK as CXTextfieldMask
} from '@sanlamcx/react-ui-next-textfield';

export type TextfieldMaskType = CXTextfieldMaskType;
export type ITextfield = CXITextfield;

export const Textfield = CXTextfield;
export const TextfieldMask = CXTextfieldMask;
